import React from 'react';
import Dialog from '@mui/material/Dialog';
import styled from 'styled-components';
import closeIcon from '../../static/img/closecircle.svg';

/** Shown when a share's preview can't load, in place of any type's dialog. */
export default function SharePreviewError({ onClose }) {
  return (
    <StyledDialog
      open
      onClose={onClose}
      aria-labelledby="share-preview-error-title"
    >
      <Header>
        <Title id="share-preview-error-title">
          We couldn't load this preview
        </Title>
        <CloseButton type="button" aria-label="Close" onClick={onClose}>
          <img src={closeIcon} alt="" width={24} height={24} />
        </CloseButton>
      </Header>
      <Body>
        Try again in a moment. If it keeps happening, the item may have been
        deleted since it was shared.
      </Body>
    </StyledDialog>
  );
}

const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    width: 480px;
    border-radius: 12px;
    padding: 24px;
    background-color: #ffffff;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

const Title = styled.h2`
  margin: 0;
  color: #000000;
  font-family: IBM Plex Sans;
  font-size: 20px;
  font-weight: 700;
`;

const CloseButton = styled.button`
  display: flex;
  padding: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const Body = styled.p`
  margin: 12px 0 0;
  color: #4b464f;
  font-family: IBM Plex Sans;
  font-size: 16px;
  line-height: 1.5;
`;
